import { render, staticRenderFns } from "./question-text.vue?vue&type=template&id=9c0f5126&scoped=true"
import script from "./question-text.vue?vue&type=script&lang=js"
export * from "./question-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0f5126",
  null
  
)

export default component.exports